/* eslint-disable react/destructuring-assignment */
import React from 'react';
import SharedTable from 'shared/ui/Table';
import hostsGeneralSchema from 'Screens/Contextualization/HostsGeneral/components/Table/schema';

const GroupBySubTable = ({
  row,
  data,
  fields,
  groupByField,
  mockData,
  themeStyles,
  getTrProps,
  isRowSelected,
  showContextMenuAction,
  isFetching,
  isTagsAllowedByLicense
}) => {
  if (!data || !data.length) return null;

  const groupRow = data[row.index];
  if (!groupRow) return null;

  const groupData = groupRow.groupData || [];
  const totalCount = groupRow.count || 0;

  const isLoadingGroup = totalCount > 0 && groupData.length === 0;

  const rowCount = totalCount || groupData.length || 5;

  const subData = isLoadingGroup
    ? mockData.slice(0, rowCount)
    : groupData;

  if (!subData.length) return null;

  const subContext = {
    isPivot: true,
    fields,
    groupBy: groupByField,
    isLoading: isLoadingGroup,
    isAllowedByLicense: false,
    isTagsAllowedByLicense,
    theme: themeStyles
  };

  return (
        <SharedTable
          schema={ hostsGeneralSchema }
          context={ subContext }
          data={ subData }
          hideHeader
          getRowProps={ (rowInfo) =>
            getTrProps(rowInfo, showContextMenuAction, isFetching)
            }
          isRowSelected={ isRowSelected }
          style={ { overflow: 'hidden' } }
        />
  );
};

export default GroupBySubTable;
